module.exports = __webpack_public_path__ + "img/nocoupon.941b437a.svg";